import React, { useState } from "react";
import styles from "./Hero.module.css";
import { submitLeadForm } from "../../../utils/payment";

const statesAndUTs = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman & Diu",
  "The Government of NCT of Delhi",
  "Jammu & Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

function Hero({ heading, description, img }) {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    message: "",
    state: "", // Add state field to form data
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitLeadForm({ ...formData, service: heading }, "service_inquiry");
    setSubmitted(true);
  };

  return (
    <>
      <div className={styles.accomodation_hero_section}>
        <div className={styles.accomodation_hero_inner}>
        <div className={styles.accomodation_hero_left}>
          <img src={img} alt={heading} />
        </div>
        <div className={styles.accomodation_hero_right}>
          <div className={styles.leftSection}>
            <h1 className={styles.subHeading} id="heading-large">
              {heading}
            </h1>
            <h2 className={styles.heading}>{description}</h2>
            {submitted ? (
              <div className="bg-green-50 text-green-700 p-4 rounded-lg">
                <p className="font-semibold">Thank you! We'll contact you within 24 hours.</p>
              </div>
            ) : (
            <form className={styles.accomodationform} onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleChange}
              />
              <input
                type="text"
                name="address"
                placeholder="Address"
                value={formData.address}
                onChange={handleChange}
              />
              <select
                name="state"
                value={formData.state}
                onChange={handleChange}
              >
                <option value="">Select State/Union Territory</option>
                {statesAndUTs.map((state, index) => (
                  <option key={index} value={state}>
                    {state}
                  </option>
                ))}
              </select>
              <textarea
                name="message"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              <button type="submit" className={styles.sendMessageBtn}>
                Get Free Quote
              </button>
            </form>
            )}
          </div>
        </div>
        </div>
      </div>
    </>
  );
}

export default Hero;
